module.exports = __webpack_public_path__ + "media/music_10.726e350c.mp3";